module.exports = "button {\n  outline: none;\n  border: none;\n  background-color: #3b7587;\n  width: 150px;\n  color: #fff;\n  padding: 10px;\n  font-weight: bold;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/main-settings/add-customer-bank/add-customer-bank.component.css
// module id = ./src/app/main-settings/add-customer-bank/add-customer-bank.component.css
// module chunks = main